// extracted by mini-css-extract-plugin
export default {"wrapper":"FormatMultiple_wrapper__AnBJ-","icon":"FormatMultiple_icon__2N4pt"};